var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"height":"40px","text":"","color":"red"},on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v("Close")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }